import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { m } from '#/paraglide/messages'
import { fmtCompact } from '#/lib/format'

interface Stats {
  totalUsers: number
  totalPrds: number
}

export function LiveStats() {
  const { data } = useQuery<Stats>({
    queryKey: ['stats'],
    queryFn: () => fetch('/api/stats').then((r) => r.json()),
    staleTime: 60_000,
  })
  const [live, setLive] = useState<Stats | null>(null)
  useEffect(() => {
    if (typeof EventSource === 'undefined') return
    const es = new EventSource('/api/stats-stream')
    es.onmessage = (ev) => {
      try {
        setLive(JSON.parse(ev.data))
      } catch {}
    }
    es.onerror = () => es.close()
    return () => es.close()
  }, [])
  const s = live ?? data
  if (!s) return null
  return (
    <div className="hidden items-center gap-2 text-xs text-muted-foreground sm:flex">
      <span className="flex items-center gap-1 font-medium text-foreground">
        <span className="size-1.5 rounded-full bg-status-done" /> {m.header_live()}
      </span>
      <span>·</span>
      <span>{m.header_users({ count: fmtCompact(s.totalUsers) })}</span>
      <span>·</span>
      <span>{m.header_prds({ count: fmtCompact(s.totalPrds) })}</span>
    </div>
  )
}
